const pageSize = 10;

//获取url中search
const queryString = (request) => {
  let params = request?.split('?')[1];
  if (!params) return {};
  let param = params.split('&');
  let obj = {};
  for (let i = 0; i < param.length; i++) {
    let paramsA = param[i].split('=');
    let key = paramsA[0];
    let value = paramsA[1];
    if (value === 'null') value = null;
    if (obj[key]) {
      obj[key] = Array.isArray(obj[key]) ? obj[key] : [obj[key]];
      obj[key].push(value);
    } else {
      obj[key] = value;
    }
  }
  return obj;
};

//节流
const throttle = (fn, time = 500) => {
  let canRun = true;
  return function () {
    if (!canRun) return;
    canRun = false;
    fn.apply(this, arguments);
    setTimeout(() => {
      canRun = true;
    }, time);
  };
};

function debounce(fun, time = 500) {
  return function (args) {
    let that = this;
    let _args = args;
    clearTimeout(fun.id);
    fun.id = setTimeout(function () {
      fun.call(that, _args);
    }, time);
  };
}

//获取当前年的第一天
const getFirstDayOfYear = (date) => {
  date.setDate(1);
  date.setMonth(0);
  return date.getTime();
};

export { pageSize, queryString, getFirstDayOfYear, throttle, debounce };
